module.exports = __webpack_public_path__ + "img/stage-arrow.e13ab784.png";